import { useMemo } from 'react';
import { useMediaQuery } from '@mui/material';
import { TIGHT_VIEWPORT_MAX_WIDTH, APP_CONTENT_TOP_OFFSET } from '../Constants/layoutBreakpoints';

/**
 * Shared D8 tight-viewport layout for StandardListView pages.
 * Returns page shell sx, list flex wrapper sx, and StandardListView props.
 */
export default function useD8ListLayout(options = {}) {
  const { enableFloatingToolbar = true, extraShellSx = {} } = options;

  const isViewportTight = useMediaQuery(`(max-width:${TIGHT_VIEWPORT_MAX_WIDTH}px)`);
  const useCompactLayout = enableFloatingToolbar && isViewportTight;

  const pageShellSx = useMemo(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${APP_CONTENT_TOP_OFFSET}px)`,
    overflow: 'hidden',
    ...extraShellSx,
  }), [extraShellSx]);

  const listFlexSx = useMemo(() => ({
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }), []);

  const listViewProps = useMemo(() => ({
    fillAvailableHeight: true,
    enableFloatingToolbar,
    bottomPaddingPx: useCompactLayout ? 8 : 40,
  }), [enableFloatingToolbar, useCompactLayout]);

  return {
    pageShellSx,
    listFlexSx,
    listViewProps,
    useCompactLayout,
    isViewportTight,
  };
}
